import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: absolute;
  left: 12px;
  display: flex;
`;